<template>
  <div class="auth-page">
    <div class="auth-page__bg"></div>
    <div class="auth-page__card">
      <img src="/logo.png" alt="Palace of Kebap" class="auth-page__logo" />
      <h2 class="auth-page__title">Willkommen zurück</h2>
      <p class="auth-page__sub">Melde dich an, um zu bestellen</p>

      <form @submit.prevent="onLogin">
        <div class="auth-input">
          <feather-icon icon="MailIcon" svgClasses="w-5 h-5" />
          <input type="email" placeholder="E-Mail" v-model="email" required />
        </div>
        <div class="auth-input">
          <feather-icon icon="LockIcon" svgClasses="w-5 h-5" />
          <input
            :type="showPw ? 'text' : 'password'"
            placeholder="Passwort"
            v-model="password"
            required
          />
          <feather-icon
            :icon="showPw ? 'EyeOffIcon' : 'EyeIcon'"
            svgClasses="w-5 h-5 cursor-pointer"
            @click="showPw = !showPw"
          />
        </div>

        <div class="flex justify-end mb-4">
          <router-link
            to="/pages/forgot-password"
            style="color: #c41e2a; font-size: 13px"
            >Passwort vergessen?</router-link
          >
        </div>

        <button type="submit" class="auth-btn auth-btn--primary">
          Anmelden
        </button>
        <button
          type="button"
          class="auth-btn auth-btn--secondary"
          @click="$router.push('/pages/register')"
        >
          Registrieren
        </button>
        <button
          type="button"
          class="auth-btn auth-btn--outline"
          @click="$router.push('/')"
        >
          Als Gast bestellen
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data() {
    return { email: "", password: "", showPw: false };
  },
  methods: {
    ...mapActions({ login: "auth/login" }),
    onLogin() {
      this.login({ email: this.email, password: this.password })
        .then(() => {
          this.$router.replace({ name: "shop" });
          this.$vs.notify({
            title: "Willkommen!",
            text: "Erfolgreich angemeldet",
            color: "success",
            position: "top-center",
          });
        })
        .catch(() => {
          this.$vs.notify({
            title: "Fehler",
            text: "E-Mail oder Passwort falsch",
            color: "danger",
            position: "top-center",
          });
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/auth.scss";
</style>
